<template>
  <v-card
    class="mx-auto"
    max-width="400"
    :disabled="!isDeviceConnected"
    theme="dark"
  >
    <v-progress-linear
      :indeterminate="!isDeviceConnected"
      color="rgb(200, 200, 200)"
    />
    <EqdaDisplay />
    <v-card-text>EQ-DA Series</v-card-text>
    <v-card-title>Device Status LEDs</v-card-title>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { PortState } from "@/enums/PortState";
import EqdaDisplay from "./EqdaDisplay.vue";
import { useModbusStore } from "@/stores/useModbusStore";

const modbusStore = useModbusStore();

const isDeviceConnected = computed(() => {
  return modbusStore.portState === PortState.connected;
});
</script>
